const convertCartItemToProduct = cartItem => {
  const brand = cartItem.brand || {}
  return {
    product_id: cartItem.utid,
    utid: cartItem.utid,
    name: cartItem.name,
    price: cartItem.selectedAmount,
    image_url: cartItem.image,
    brand: brand.name,
    fee: cartItem.fee,
    fulfillmentType: cartItem.fulfillmentType
  }
}

export const convertCartItemsToProducts = cartItems => {
  const cartItemsToMap = cartItems || []
  return cartItemsToMap.map((cartItem, index) => ({
    ...convertCartItemToProduct(cartItem),
    position: index
  }))
}
